let language = {
    CATALOG_PRODUCT_SORT_RECOMMENDED:"推荐",
    CATALOG_PRODUCT_SORT_NEW:"新的",
    CATALOG_PRODUCT_SORT_PRICE:"价格",
    CATALOG_PRODUCT_SORT_PRICE_LOW:"从低到高",
    CATALOG_PRODUCT_SORT_PRICE_HIGH:"从高到低",
    CATALOG_PRODUCT_SEARCH_FOR:"查找",
    CATALOG_PRODUCT_NAV_HEAD:"产品",
    CATALOG_PRODUCT_EMPTY:"目标产品为空",
    CATALOG_PRODUCT_LOW_PRICE:"低至",
    CATALOG_PRODUCT_MORE_BTN:"更多..."
};

export { language }